import { videoModels } from '@flowmuse/models/video';
import type { FrameRole } from '@/lib/xyflow';

export function computeModelCapabilities(modelId?: string) {
  const supportsInput = modelId ? (videoModels as any)?.[modelId]?.supportsInput as string[] | undefined : undefined;
  const supportsFirstLast = Array.isArray(supportsInput) && supportsInput.includes('first_last');
  const supportsFirst = Array.isArray(supportsInput) && supportsInput.includes('first');
  const supportsReference = Array.isArray(supportsInput) && supportsInput.includes('reference');
  const supportsImageCondition = Array.isArray(supportsInput) && (
    supportsInput.includes('i2v') || supportsFirst || supportsFirstLast || supportsReference
  );
  const textOnlyModel = Array.isArray(supportsInput) && !supportsImageCondition;
  return { supportsFirst, supportsFirstLast, supportsReference, textOnlyModel } as const;
}

export function roleOfEdge(e: any, mirror: Record<string, FrameRole>): FrameRole {
  return (((e?.data as any)?.frameRole as any) ?? mirror[e?.source as string]) as FrameRole;
}

